import React, { useEffect, useState } from "react";
import TopHeader from "../Dashoboard/TopHeader";
import { Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { saveLoader } from "../../redux/slice/loaderNoti";
import CloseIcon from "@mui/icons-material/Close";
import {
  useAddTimeSlotMutation,
  useEditTimeSlotMutation,
  useLazyRoomBookingCreateQuery,
  useLazyRoomBookingSlotQuery,
  useLazyShowRoomQuery,
  useRoomAddMutation,
  useRoomEditMutation,
  useLazyDeleteRoomImgQuery,
} from "../../redux/api/api";
import { FaRegEdit } from "react-icons/fa";
import ProductZoom from "../../components/ProductZoom";

const RoomPhase = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.itemType;
  const service_type = location?.state?.service_type;
  const [btn, setBtn] = useState(false);
  const [modal, setModal] = useState(false);

  const [timeslotUpdate, setTimeSlotUpdate] = useState({});
  const [roomBookingList, setRoomBookingList] = useState({});
  const [dayOutingData, setDayOutingData] = useState({});
  const [amenities, setamenities] = useState([]);
  const [total_rooms, settotal_rooms] = useState("");
  const [room_name, setroom_name] = useState("");
  const [child_price, setchild_price] = useState("");
  const [min_persons, setmin_persons] = useState("");
  const [max_persons, setmax_persons] = useState("");
  const [min_childrens, setmin_childrens] = useState("");
  const [max_childrens, setmax_childrens] = useState("");
  const [admin_commision, setadmin_commision] = useState("");
  const [baseprice, setbaseprice] = useState("");
  const [extra_person_charge, setextra_person_charge] = useState("");
  const [percentage, setpercentage] = useState("");
  const [weekend, setWeekend] = useState(false);
  const [weekendErr, setWeekendErr] = useState(false);
  const [amenitiesErr, setamenitiesErr] = useState(false);
  const [total_roomsErr, settotal_roomsErr] = useState(false);
  const [room_nameErr, setroom_nameErr] = useState(false);
  const [child_priceErr, setchild_priceErr] = useState(false);
  const [min_personsErr, setmin_personsErr] = useState(false);
  const [min_childrensErr, setmin_childrensErr] = useState(false);
  const [max_childrensErr, setmax_childrensErr] = useState(false);
  const [max_personsErr, setmax_personsErr] = useState(false);
  const [percentageErr, setpercentageErr] = useState(false);
  const [admin_commisionErr, setadmin_commisionErr] = useState(false);
  const [basepriceErr, setbasepriceErr] = useState(false);
  const [extra_person_chargeErr, setextra_person_chargeErr] = useState(false);

  const [images, setimages] = useState([]);
  const [imagesErr, setimagesErr] = useState(false);
  const [slotList, setSlotList] = useState({});
  const [updated, setUpdated] = useState({});
  const [slot_hrs, setslot_hrs] = useState("23 HRS");

  // RTK QUERY
  const [roomBookingCreate] = useLazyRoomBookingCreateQuery();
  const [roomAddApi] = useRoomAddMutation();
  const [roomEditApi] = useRoomEditMutation();
  const [showRoomApi] = useLazyShowRoomQuery();
  const [roomBookingSlotApi] = useLazyRoomBookingSlotQuery();
  const [editTimeSlotApi] = useEditTimeSlotMutation();
  const [addTimeSlotApi] = useAddTimeSlotMutation();
  const [deleteRoomImgApi] = useLazyDeleteRoomImgQuery();

  const roomBookingCreateApi = () => {
    roomBookingCreate()
      .unwrap()
      .then((res) => {
        setRoomBookingList(res);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    roomBookingCreateApi();
  }, []);

  const getShowRoom = (id) => {
    showRoomApi(id)
      .unwrap()
      .then((res) => {
        let data = res?.room;
        setroom_name(data?.room_name);
        settotal_rooms(data?.total_rooms);
        setmin_persons(data?.min_persons);
        setmax_persons(data?.max_persons);
        setmin_childrens(data?.min_childrens);
        setmax_childrens(data?.max_childrens);
        setUpdated(data);
        let amenities_ = [];

        data?.amenities?.map((item, ind) => {
          amenities_.push(item?.amenity?.id);
        });

        setamenities(amenities_);
        let temp = [];
        temp[0] = data?.images;
        setimages(temp);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const roomBookingSlot = () => {
    let params = `${location?.state?.item?.id}/${slot_hrs}/${service_type}`;
    dispatch(saveLoader(true));
    setBtn(true);
    roomBookingSlotApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err", err);
      });
  };

  const deleteRoomImg = (id) => {
    dispatch(saveLoader(true));
    setBtn(true);
    deleteRoomImgApi(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
        if (res?.status == "success") {
          Swal.fire({
            text: res?.message,
            icon: "success",
          });
          onClose();
          getShowRoom(location?.state?.item?.id);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.item?.id) {
      getShowRoom(location?.state?.item?.id);
      roomBookingSlot();
    }
  }, []);

  const handleChange = (selectedItems) => {
    let flavors = [];
    for (let i = 0; i < selectedItems.length; i++) {
      flavors.push(selectedItems[i].value);
    }
    setamenities(flavors);
  };

  const submitHandler = () => {
    if (
      room_name?.length == 0 ||
      total_rooms?.length == 0 ||
      total_rooms?.length == 0 ||
      min_childrens?.length == 0 ||
      min_persons?.length == 0 ||
      (types !== "edit" && baseprice?.length == 0) ||
      (types !== "edit" && extra_person_charge?.length == 0) ||
      amenities?.length == 0 ||
      images?.length == 0 ||
      (types !== "edit" && admin_commision?.length == 0) ||
      max_persons?.length == 0 ||
      max_childrens?.length == 0
    ) {
      setroom_nameErr(true);
      settotal_roomsErr(true);
      setmin_childrensErr(true);
      setmax_childrensErr(true);
      setmax_personsErr(true);
      setmin_personsErr(true);
      setimagesErr(true);
      setamenitiesErr(true);

      if (types !== "edit") {
        setbasepriceErr(true);
        setadmin_commisionErr(true);
        setextra_person_chargeErr(true);
      }
    } else {
      const formdata = new FormData();
      formdata.append("amenities", amenities?.toString());
      formdata.append("room_name", room_name);
      formdata.append("total_rooms", total_rooms);
      formdata.append("min_persons", min_persons);
      formdata.append("min_childrens", min_childrens);
      formdata.append("max_persons", max_persons);
      formdata.append("max_childrens", max_childrens);

      for (var k = 0; k < images[0].length; k++) {
        if (images[0][k].name) {
          formdata.append("images[" + k + "]", images[0][k]);
        }
      }

      if (baseprice) {
        formdata.append("base_price", baseprice);
      }

      if (extra_person_charge) {
        formdata.append("extra_person_charge", extra_person_charge);
      }

      if (admin_commision) {
        formdata.append("admin_commission", admin_commision);
      }

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        roomEditApi({
          id: location?.state?.item?.id,
          payload: formdata,
        })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err", err);
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        roomAddApi({
          id: location?.state?.data?.id,
          type: service_type,
          payload: formdata,
        })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err", err);
          });
      }
    }
  };

  const handleImages = (value) => {
    let temp = [];
    temp.push(value);
    setimages(temp);
  };

  const onOpen = (item) => {
    setbaseprice(item?.total_price);
    setextra_person_charge(item?.extra_person_charge);
    setadmin_commision(item?.admin_commission);
    setTimeSlotUpdate(item);
    setModal(true);
  };

  const onClose = () => {
    setbaseprice("");
    setextra_person_charge("");
    setadmin_commision("");
    setbasepriceErr(false);
    setextra_person_chargeErr(false);
    setadmin_commisionErr(false);
    setTimeSlotUpdate({});
    setModal(false);
  };

  const submitTimeSlot = () => {
    if (
      baseprice?.length == 0 ||
      extra_person_charge?.length == 0 ||
      admin_commision?.length == 0
    ) {
      setbasepriceErr(true);
      setadmin_commisionErr(true);
      setextra_person_chargeErr(true);
    } else {
      const formdata = new FormData();
      formdata.append("total_price", baseprice);
      formdata.append("extra_person_charge", extra_person_charge);
      formdata.append("admin_commission", admin_commision);

      if (timeslotUpdate?.id) {
        dispatch(saveLoader(true));
        setBtn(true);
        editTimeSlotApi({
          id: timeslotUpdate?.id,
          payload: formdata,
        })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              onClose();
              getShowRoom(location?.state?.item?.id);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err", err);
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        addTimeSlotApi({
          id: location?.state?.data?.id,
          type: service_type,
          payload: formdata,
        })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              onClose();
              getShowRoom(location?.state?.item?.id);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err", err);
          });
      }
    }
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={types == "edit" ? "edit-phase" : "add-phase"} />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Room Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setroom_name(e.target.value)}
                  value={room_name}
                />
              </div>
              {room_name?.length == 0 && room_nameErr && (
                <p className="err">Enter Room Name</p>
              )}
            </div>
            {room_name && (
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Amenities
                  </label>
                  <select
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => handleChange(e.target.selectedOptions)}
                    value={amenities}
                    multiple={true}
                    size={4}
                  >
                    {roomBookingList?.amenities?.map((item, ind) => {
                      return (
                        <option value={item?.id} key={ind}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {amenities?.length == 0 && amenitiesErr && (
                  <p className="err">Select Amenities</p>
                )}
              </div>
            )}
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  No. of. Rooms
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => settotal_rooms(e.target.value)}
                  value={total_rooms}
                  type={"number"}
                />
              </div>
              {total_rooms?.length == 0 && total_roomsErr && (
                <p className="err">Enter No. of. Rooms</p>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Minimum Persons
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setmin_persons(e.target.value)}
                  value={min_persons}
                  type={"number"}
                />
              </div>
              {min_persons?.length == 0 && min_personsErr && (
                <p className="err">Enter Minimum Persons</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Maximum Persons
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setmax_persons(e.target.value)}
                  value={max_persons}
                  type={"number"}
                />
              </div>
              {max_persons?.length == 0 && max_personsErr && (
                <p className="err">Enter Maximum Persons</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Minimum Childrens
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setmin_childrens(e.target.value)}
                  value={min_childrens}
                  type={"number"}
                />
              </div>
              {min_childrens?.length == 0 && min_childrensErr && (
                <p className="err">Enter Minimum Childrens</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Maximum Childrens
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setmax_childrens(e.target.value)}
                  value={max_childrens}
                  type={"number"}
                />
              </div>
              {max_childrens?.length == 0 && max_childrensErr && (
                <p className="err">Enter Maximum Childrens</p>
              )}
            </div>

            <div className="col-md-12 mb-3 mt-3">
              <div className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                Image Upload 307 X 207 (pixel)
              </div>
              <div className="col-md-6 mt-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Upload Images
                  </label>
                  <input
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => handleImages(e.target.files)}
                    type={"file"}
                    accept="image/jpeg, image/png"
                    multiple
                  />
                </div>
                {images?.length == 0 && imagesErr && (
                  <p className="err">Upload Images</p>
                )}
              </div>
            </div>
            <div className="col-md-12 text-end px-5 mt-4 mb-5">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
          {types == "edit" ? (
            <Row>
              {updated?.timeslots?.map((item, ind) => {
                return (
                  <div key={ind}>
                    <div className="col-md-12 mb-3">
                      <div className="head-dest d-flex ac-jb">
                        {item?.timeslot?.name}
                        <button
                          className="d-flex ac-jc gap-1 btn btn-secondary f2"
                          style={{ padding: "8px" }}
                          onClick={() => onOpen(item)}
                        >
                          <FaRegEdit />
                        </button>
                      </div>
                    </div>
                    <div className="user-detail-table">
                      <table className="tabledetails table-borderless user-det w-100 mb-5">
                        <tbody>
                          <tr>
                            <td style={{ width: "40%" }}>Base Price</td>
                            <td>:</td>
                            <td>{item?.total_price}</td>
                          </tr>
                          <tr>
                            <td style={{ width: "40%" }}>
                              Extra Person Charge
                            </td>
                            <td>:</td>
                            <td>₹{item?.extra_person_charge}</td>
                          </tr>
                          <tr>
                            <td style={{ width: "40%" }}>Admin Commission</td>
                            <td>:</td>
                            <td>{item?.admin_commission}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })}
              <h2 class="content-heading">
                Property{" "}
                <small>
                  <code class="text-lowercase">Images</code>
                </small>
              </h2>
              <div className="d-flex gap-3 mb-5">
                <div className="col-md-4 mx-3">
                  {updated?.images?.map((item, ind) => {
                    return (
                      <div key={ind} className={"mt-2"}>
                        <ProductZoom image_url={item?.image} />
                      </div>
                    );
                  })}
                </div>
              </div>
            </Row>
          ) : (
            <Row>
              <div className="col-md-12 mb-3">
                <div className="head-dest">23 Hrs Slot</div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Base Price
                  </label>
                  <input
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => setbaseprice(e.target.value)}
                    value={baseprice}
                    type={"number"}
                  />
                </div>
                {baseprice?.length == 0 && basepriceErr && (
                  <p className="err">Enter Base Price</p>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Extra Person Charge
                  </label>
                  <input
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => setextra_person_charge(e.target.value)}
                    value={extra_person_charge}
                    type={"number"}
                  />
                </div>
                {extra_person_charge?.length == 0 && extra_person_chargeErr && (
                  <p className="err">Enter Extra Person Charge</p>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Admin Commision
                  </label>
                  <input
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => setadmin_commision(e.target.value)}
                    value={admin_commision}
                    type={"number"}
                  />
                </div>
                {admin_commision?.length == 0 && admin_commisionErr && (
                  <p className="err">Enter Admin Commision</p>
                )}
              </div>
            </Row>
          )}
        </div>
      </div>

      <Modal
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="p-3">
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20">
                {updated?.id ? "Edit" : "Add"} Time Slot
              </label>
              <button className="cust-btn" onClick={() => onClose(false)}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row className="mt-4">
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Base Price
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setbaseprice(e.target.value)}
                  value={baseprice}
                  type={"number"}
                />
              </div>
              {baseprice?.length == 0 && basepriceErr && (
                <p className="err">Enter Base Price</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Extra Person Charge
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setextra_person_charge(e.target.value)}
                  value={extra_person_charge}
                  type={"number"}
                />
              </div>
              {extra_person_charge?.length == 0 && extra_person_chargeErr && (
                <p className="err">Enter Extra Person Charge</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Admin Commision
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setadmin_commision(e.target.value)}
                  value={admin_commision}
                  type={"number"}
                />
              </div>
              {admin_commision?.length == 0 && admin_commisionErr && (
                <p className="err">Enter Admin Commision</p>
              )}
            </div>
          </Row>
          <Row className="mt-4 d-flex ac-jc">
            <div className="col-md-2 text-center">
              <button
                className={`submit-btn ${btn ? "opacity-50" : ""}`}
                onClick={() => submitTimeSlot()}
                disabled={btn}
              >
                OK
              </button>
            </div>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default RoomPhase;
